import { el, setAttr } from 'redom';

class Option {

  constructor() {

    this.input = null;
    this.label = null;

    this.el = el('.checkbox-group-option', [
      this.renderInput(),
      this.renderLabel()
    ]);

  }

  renderInput() {

    this.input = el('input.checkbox-group-option-input', {
      type: 'radio',
      disabled: true
    });

    return this.input;

  }

  renderLabel() {

    this.label = el('.checkbox-group-option-label');

    return this.label;

  }

  updateLabel(option) {

    this.label.textContent = option;

  }

  updateInput(option, fieldRow) {

    setAttr(this.input, {
      name: fieldRow.label
    });

  }

  update(option, index, options, fieldRow) {

    this.updateLabel(option);

    this.updateInput(option, fieldRow);

  }

}

export default Option;